"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var statsig_js_1 = require("statsig-js");
var StatsigContext_1 = __importDefault(require("./StatsigContext"));
var Statsig_1 = __importDefault(require("./Statsig"));
/**
 * A synchronous hook to check the value of an experiment.  To ensure correctness, wait for SDK initialization before
 * calling.
 * @param experimentName - the name of the experiment to check
 * @param keepDeviceValue -
 * @param ignoreOverrides -
 * @returns a ConfigResult indicating the DynamicConfig backing the experiment, and the loading state of the SDK
 */
function default_1(experimentName, keepDeviceValue, ignoreOverrides) {
    if (keepDeviceValue === void 0) { keepDeviceValue = false; }
    var _a = (0, react_1.useContext)(StatsigContext_1.default), initialized = _a.initialized, initStarted = _a.initStarted, userVersion = _a.userVersion;
    var config = (0, react_1.useMemo)(function () {
        return initStarted
            ? Statsig_1.default.getExperiment(experimentName, keepDeviceValue, ignoreOverrides)
            : new statsig_js_1.DynamicConfig(experimentName, {}, '', {
                time: Date.now(),
                reason: statsig_js_1.EvaluationReason.Uninitialized,
            });
    }, [
        initialized,
        initStarted,
        experimentName,
        userVersion,
        keepDeviceValue,
        ignoreOverrides,
    ]);
    return {
        isLoading: !initialized,
        config: config,
    };
}
exports.default = default_1;
